import { types } from 'mobx-state-tree';

import moment from 'moment-timezone';

import DateTime from '@utils/mst/types/DateTime';

import Coach from './Coach';

const OrganizationalService = types
  .model('OrganizationalService', {
    id: types.identifierNumber,
    name: types.string,
    description: types.string,
    createdAt: DateTime,
    updatedAt: types.maybeNull(DateTime),
    deletedAt: types.maybeNull(DateTime),
    createdBy: types.reference(Coach),
  })
  .views((self) => ({
    get createdAtMoment(): string {
      return moment(self.createdAt).format('DD MMMM YYYY hh:mm A');
    },
  }));

export default OrganizationalService;
